<template>
    <div class="store-creater-info-container">
        <van-nav-bar title="管理者" />
        <div class="store-creater-banner">
            <van-image round width="60px" height="60px" :src="avatar" />
            <div class="name">{{ uname }}</div>
            <div class="type">{{ mallBranchStoreName }}</div>
        </div>
        <div class="store-creater-item">
            <van-cell title="联系电话" is-link :value="call" />
            <van-cell title="所属门店" is-link :value="mallBranchStoreName" @click="showPicker = true" />
            <van-cell title="机构转让" is-link @click="agencyTransfer" />
        </div>
        <div class="store-creater-delete">
            <van-cell title="删除" is-link @click="delCreater" />
        </div>
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker show-toolbar :columns="branchstoreList" @cancel="showPicker = false" @confirm="onConfirm" />
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { reqDelBusiness, reqBranchstore, reqTransferManager, reqUpdateBusiness } from '../api/business';
export default {
    data() {
        return {
            showPicker: false,
            phone: '',
            id: '',
            mallOrgBusinessID: '',
            avatar: '',
            uname: '',
            call: '',
            mallBranchStoreID: '', // 分店id
            mallBranchStoreName: '', // 分店名称
            branchstoreList: [] // 分店信息
        };
    },
    mounted() {
        this.phone = this.$globalData.phone1;
        const { avatar, uname, phone, mallBranchStoreID, mallOrgBusinessID } = JSON.parse(this.$route.query.item);
        this.avatar = avatar;
        this.uname = uname;
        this.call = phone;
        this.mallBranchStoreID = mallBranchStoreID;
        this.mallOrgBusinessID = mallOrgBusinessID;
        this.getBranchstore();
    },
    methods: {
        // 获取分店列表
        getBranchstore() {
            reqBranchstore({ phone: this.phone, audit: 0 }).then(res => {
                console.log('分店列表：', res.data.rows);
                const list = res.data.rows || [];
                this.branchstoreList = list.map((item, index) => {
                    return { text: item.simpleName, ...item };
                });
                const currentBranchStore = this.branchstoreList.find(item => item.mallBranchStoreID == this.mallBranchStoreID);
                this.mallBranchStoreName = currentBranchStore.simpleName || '';
            });
        },
        // 机构转让打开弹框
        agencyTransfer() {
            Dialog.confirm({
                title: '转让提示',
                message: '转让本机构，对方将拥有本机构最高管理权限，你的身份将更改为管理员，确认将机构转让给该管理员吗?',
                confirmButtonText: '确认转让',
                beforeClose: (action, done) => {
                    if (action === 'confirm') {
                        reqTransferManager({
                            mallOrgBusinessID: this.mallOrgBusinessID,
                            phone: this.call,
                            mallBranchStoreID: this.mallBranchStoreID,
                            chargePhone: this.phone
                        })
                            .then(() => {
                                Toast.success('转让成功！');
                                this.$router.push('/index');
                            })
                            .catch(() => {
                                Toast.error('转让失败！');
                            })
                            .finally(() => {
                                done();
                            });
                    } else {
                        done();
                    }
                }
            });
        },
        // 删除创建者
        delCreater() {
            Dialog.confirm({
                title: '删除提示',
                message: '是否确认删除',
                beforeClose: (action, done) => {
                    if (action === 'confirm') {
                        reqDelBusiness({ id: this.mallOrgBusinessID, phone: this.phone })
                            .then(res => {
                                this.$router.push('/storeAdmin');
                            })
                            .catch(() => {
                                Toast.error('删除失败！');
                            })
                            .finally(() => {
                                done();
                            });
                    } else {
                        done();
                    }
                }
            });
        },
        // 更新门店
        onConfirm({ mallBranchStoreID, simpleName }) {
            reqUpdateBusiness({
                mallOrgBusinessID: this.mallOrgBusinessID,
                phone: this.call,
                mallBranchStoreID: mallBranchStoreID,
                chargePhone: this.phone
            })
                .then(() => {
                    this.mallBranchStoreName = simpleName;
                    this.mallBranchStoreID = mallBranchStoreID;
                    Toast.success('修改成功！');
                })
                .catch(() => {
                    Toast.error('修改失败！');
                })
                .finally(() => {
                    this.showPicker = false;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.store-creater-info-container {
    height: 100vh;
    background-color: #eeeeee;

    .store-creater-banner {
        height: 200px;
        background-color: #ff6533;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .name {
            font-size: 14px;
            color: #ffffff;
            margin: 10px 0 5px;
        }

        .type {
            color: #ffffff;
        }
    }

    .store-creater-item {
    }
    .store-creater-delete {
        margin-top: 15px;
    }
}
</style>
